/**
 * @generated SignedSource<<70b62082c85dc5138e762597e1205dba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type areFiltersApplied_itemSearch$data = {
  readonly appliedFilters: ReadonlyArray<{
    readonly name: string | null;
  } | null> | null;
  readonly " $fragmentType": "areFiltersApplied_itemSearch";
};
export type areFiltersApplied_itemSearch$key = {
  readonly " $data"?: areFiltersApplied_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"areFiltersApplied_itemSearch">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "areFiltersApplied_itemSearch"
};

(node as any).hash = "8b7ffd7dbe40102222f4f22dbc7f7799";

export default node;
